import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buyEntriesCongratsDialogTitle: {
    id: 'pointsSweeps:buyEntries:congratsDialog:title',
    defaultMessage: 'Awesome!',
    description: 'Buy entries congrats dialog title',
  },
  buyEntriesCongratsDialogDescription: {
    id: 'pointsSweeps:buyEntries:congratsDialog:description',
    defaultMessage: 'You bought {entries, plural, one {# entry} other {# entries}}',
    description: 'Buy entries congrats dialog description',
  },
  offerDetailsNotFoundPopupDescription: {
    id: 'offer-details:not-found:popup:description',
    defaultMessage: 'Looks like that offer is not available, check out some other great offers in the app today!',
    description: 'Not offer found description',
  },
  offerDetailsIneligibilityReasonPurchasableEligibilityConstraintFailed: {
    id: 'offer-details:ineligibility-reason:purchasable-eligibility-constraint-failed',
    defaultMessage: 'You have another award that prevents you from receiving this award.',
    description:
      'Message to display when user not allowed to purchase new offer before using/returning existing reward',
  },
});
